import { createSelector } from '@ngrx/store';
import { ResponseStateMap } from '../reducers/response.reducer';
import { selectGandalfState } from '../reducers/root';

export const selectGandalfResponses = createSelector(selectGandalfState, state => state.responses);

export const selectGandalfResponse = (props: {key: string}) =>
	createSelector(selectGandalfResponses, (state: ResponseStateMap) => state.get(props.key));
